// src/pages/GameLinkPage.js
import React, { useEffect, useState } from "react";

const GameLinkPage = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const response = await fetch("https://api.gamegems.co/web/games/link");
        if (!response.ok) throw new Error("Failed to fetch link");

        const result = await response.json();

        // ✅ Validate response
        if (result?.status === true && result?.message === "success") {
          const link = result?.data?.link;
          if (link) {
            window.location.href = link; // 🔄 Auto redirect
          } else {
            throw new Error("Link not found in API response");
          }
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAndRedirect();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-black px-4">
      <div className="text-center text-white">
        {loading && <p>Loading link...</p>}
        {error && <p className="text-red-500 break-words">Error: {error}</p>}
      </div>
    </div>
  );
};

export default GameLinkPage;
